var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebPushNodeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FC8F37"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9519 17.2047L18.0066 13.875V6.625C18.0066 6.34844 17.7831 6.125 17.5066 6.125H6.50656C6.23 6.125 6.00656 6.34844 6.00656 6.625V13.875L5.06125 17.2047C4.94406 17.5312 5.18469 17.875 5.53156 17.875H18.4816C18.8284 17.875 19.0691 17.5312 18.9519 17.2047ZM7.13156 7.25H16.8816V13.4219H7.13156V7.25ZM10.6987 16.75L10.8253 16.1719H13.1737L13.3003 16.75H10.6987ZM14.1987 16.75L13.9003 15.3953C13.8878 15.3375 13.8362 15.2969 13.7784 15.2969H10.2222C10.1628 15.2969 10.1128 15.3375 10.1003 15.3953L9.80187 16.75H6.35969L7.02062 14.4219H16.9925L17.6534 16.75H14.1987Z",
    fill: "#FFF4F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebPushNodeIcon);
export default __webpack_public_path__ + "static/media/webPushNodeIcon.24929f80760e334726b68ca28e1aa44e.svg";
export { ForwardRef as ReactComponent };